<div class="filters-container" *ngIf="isFilterPanelOpen">
  <div class="filter-empty-state" *ngIf="filters?.length === 0">
    <capra-icon class="icon-no-filters"></capra-icon>
    <p>Add filters to your report by clicking the Add Filter link at the top of the page.</p>
  </div>
  <div class="cta-container {{ buttonPosition }}" *ngIf="filters && buttonPosition === 'top'">
    <capra-button
      *ngIf="!showSetDefault && isViewer && !isEmbedded && (enableApplyAndGenerateLink$ | async)"
      [disabled]="!isDirty"
      class="apply-and-generate-link-cta"
      text="Apply and Generate Link"
      variant="primary"
      size="small"
      color="neutral"
      (clicked)="applyAndGenerateLink()"
    ></capra-button>
    <span
      capraTooltip
      [tooltipContent]="'Filters as originally shared'"
      tooltipPlacement="top"
    >
      <capra-button
        *ngIf="!showSetDefault"
        [disabled]="!isDirty"
        class="reset-cta"
        text="Reset"
        variant="secondary"
        size="small"
        color="neutral"
        (clicked)="onResetAllFilters()"
      ></capra-button>
    </span>
    <capra-button
      *ngIf="showSetDefault"
      [disabled]="!isDirty"
      class="set-as-default-cta"
      text="Set as default"
      variant="secondary"
      size="small"
      color="neutral"
      (clicked)="setDefault()"
    ></capra-button>
    <capra-button
      text="Apply changes"
      variant="primary"
      size="small"
      color="default"
      (clicked)="apply()"
    ></capra-button>
  </div>
  <div *ngIf="filters" class="filter-type-container" dndDropzone (dndDrop)="onDrop($event)">
    <div *ngFor="let filter of filters; last as isLast; trackBy: trackByFn">
      <mode-filter-container
        [class.last]="isLast"
        [filter]="filter"
        [filterOption]="filterOptions[filter.token]"
        [isLoading]="!filter.isLoaded"
        [showSettingsMenu]="showSettingsMenu"
        [isOrphan]="orphanedFilters.has(filter.token)"
        [tooManySelected]="hasTooManySelected(filter.token)"
        [isCalc]="isCalcField(filter.token)"
        [showDropdownToggle]="ffDropdownEnabled"
        [dragAndDropEnabled]="ffDragAndDropEnabled"
        [displayRelevantValuesEnabled]="ffDisplayRelevantValuesEnabled"
        (updateSelectControlType)="onSelectControlTypeChange($event.field, $event.type)"
        (updateReportFilterType)="onUpdateReportFilterType($event.field, $event.type)"
        (selectChange)="onSelectChange($event.token, $event.selection)"
        (multiSelectChange)="onMultiSelectChange($event.filter, $event.selection, $event.searchTerm)"
        (dragStarted)="onDragStart($event)"
        (dragEnded)="onDragEnd()"
        (deleteFilter)="onDeleteFilter($event)"
        (rangeChange)="onRangeChange($event.filter, $event.token)"
        (moveFilterToTop)="onMoveFilter($event.token, 'top')"
        (moveFilterToBottom)="onMoveFilter($event.token, 'bottom')"
        (moveFilterUp)="onMoveFilter($event.token, 'up')"
        (moveFilterDown)="onMoveFilter($event.token, 'down')"
        (resetFilter)="onResetFilter($event)"
        (showAll)="onShowAllChanged($event.token, $event.shouldShowAll)"
        (showRelevantValues)="onShowRelevantValuesChanged($event.filterToken, $event.showRelevantValues)"
      ></mode-filter-container>
    </div>
    <div dndPlaceholderRef class="placeholder"></div>
  </div>
  <div class="cta-container {{ buttonPosition }}" *ngIf="filters && buttonPosition === 'bottom'">
    <div>
      <capra-button
        *ngIf="!showSetDefault && isViewer && !isEmbedded && (enableApplyAndGenerateLink$ | async)"
        [disabled]="!isDirty"
        class="apply-and-generate-link-cta"
        text="Apply filter & generate sharable URL"
        variant="primary"
        size="small"
        color="neutral"
        (clicked)="applyAndGenerateLink()"
      ></capra-button>
    </div>
    <div style="display: flex" class="cta-container-buttons">
      <span
        capraTooltip
        [tooltipContent]="'Filters as originally shared'"
        tooltipPlacement="top"
      >
        <capra-button
          *ngIf="!showSetDefault"
          [disabled]="!isDirty"
          class="reset-cta"
          text="Reset"
          variant="secondary"
          size="small"
          color="neutral"
          (clicked)="onResetAllFilters()"
        ></capra-button>
      </span>
      <capra-button
        *ngIf="showSetDefault"
        [disabled]="!isDirty"
        class="set-as-default-cta"
        text="Set as default"
        variant="secondary"
        size="small"
        color="neutral"
        (clicked)="setDefault()"
      ></capra-button>
      <capra-button
        text="Apply changes"
        variant="primary"
        size="small"
        color="default"
        (clicked)="apply()"
      ></capra-button>
    </div>
  </div>
</div>
